import Hero from "../components/Hero";
import { Link } from "react-router-dom";
import VideoGridSection from "../components/section-templates/VideoGridSection";

export default function Home() {
  const videos = [
    {
      title: "[AMV] - Project Engage",
      src: "https://www.youtube.com/watch?v=JP41A72Upl0",
      description:
        "Another AMV that I created. Overall work time is around a month, mainly because I was working full time.",
      tags: [
        "After Effects",
        "Premiere",
        "Color Grading",
        "VFX",
        "Compositing",
        "Typography",
      ],
    },

    {
      title: "[Uni Project] - 11:11",
      src: "https://www.youtube.com/watch?v=GnzWvZVpr_A",
      description:
        "One of the few projects, where I focused more in Premiere Pro.",
      tags: ["Premiere Pro", "After Effects"],
    },
    {
      title: "[AMV] - Lullaby",
      src: "https://www.youtube.com/watch?v=_JR59p_4bak",
      description:
        "One of the few projects, where I focused more in Premiere Pro.",
      tags: ["Premiere Pro", "After Effects"],
    },
    {
      title: "[AMV] - I'll be gone]",
      src: "https://www.youtube.com/watch?v=SxirnLJvPb4",
      description:
        "This is pretty much where I started dwelving more into Typography animation.",
      tags: ["After Effects", "Premiere Pro"],
    },
    {
      title: "[AMV] - Revenge]",
      src: "https://www.youtube.com/watch?v=8P2XNErpK8c",
      description:
        "Random title name. This is where the trend of shorter AMVs started. And I decided to give that a try as well",
      tags: ["After Effects"],
    },
    {
      title: "BTC Halving Explainer",
      src: "https://www.youtube.com/watch?v=J0LEgKHLwFM",
      description: "Explaining the Bitcoin halving event.",
      tags: ["Premiere Pro", "After Effects", "Photoshop", "Illustrator"],
    },
  ];

  return (
    <>
      <Hero
        title="Personal Projects"
        subtitle="Some of my personal projects and experiments."
        mediaType="video"
        mediaSrc="../assets/hero-video-particles-4.webm"
      ></Hero>

      <VideoGridSection
        title="This page is still under construction"
        description="In the meantime, here are some of my Personal Projects."
        videos={videos}
      />
    </>
  );
}
